import React from 'react';
import PropTypes from 'prop-types';

import './style.css';

const Projects = ({ title, value }) => {
    return (
        <div className="ProjectMeta">
            <span className="ProjectMeta__title">{title}</span>
            <br />
            <span className="ProjectMeta__value">{value}</span>
        </div>
    );
};

Projects.propTypes = {
    title: PropTypes.string,
    value: PropTypes.string
};

Projects.defaultProps = {
    title: 'Meta Title',
    value: 'Meta Value'
};

export default Projects;



// WEBPACK FOOTER //
// ./src/components/atoms/textMeta/index.js